module.exports = __webpack_public_path__ + "img/SueloDesnudo.5ded3ec8.jpg";